import { Inject, Injectable } from "@angular/core";
import {
  PerPageList,
  LoginBy,
  Permissions,
  DistanceUnit,
  DriverType,
  DriverStatus,
  UserType,
  DATE_FORMAT,
  VehicleTypeTypes,
  DeviceType,
  emailRegex,
  VehicleType,
  PaymentGateway,
  PaymentGatewayString,
  DefaultImages,
  NameMaxLength,
  PaymentTransactionStatus,
  PdfSize,
  SocketEvents,
  OTPSendMode,
  PaymentGatewayType,
  PaymentGatewayEnum,
  PaymentPurposeType,
  MapType,
  BookingHistoryMainType,
  SetCurrencySignUnit,
  BookingHistoryPageType,
  PaymentModeStrings,
  ExportType,
  ExportHistoryStatusEnum,
  fixedNumber,
  FilterFields,
  DriverTypeArray,
  MassNotificationEntities,
  DeviceTypeEnum,
  FilterType,
  MapPinImages,
  ChatType,
  UserTypeString,
  ViewType,
  PaymentModeListStrings,
  AddressType,
  AddressTypeString,
  DriverTabTypeString,
  TripTabTypeString,
  ChargeType,
  PriceParamEnumString,
  PriceParamEnum,
  PaymentTransactionStatusString,
  backendMaxInt,
  viewEstimateParamEnumString,
  TripTabType,
  PaymentMode,
  TimeFormatEnum,
  VariantType,
  UnitType,
  UnitTypeString,
  PriceSign,
  HomeScreenViewType,
  PaymentGatewayEnumArray,
  PaymentGatewayCardEnumArray,
  PaymentGatewayHandleUrlEnumArray,
  PaymentGatewayHandleHtmlEnumArray
} from "../constants/constants";
import { Router } from "@angular/router";
import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { environment } from "src/environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { BehaviorSubject } from "rxjs";
import {
  BookingStatus,
  BookingType,
  PriceMode,
  PriceModeString,
  BookingStatusStrings,
  BookingTypeString,
  BookingHistoryBookingTypeArray,
  BookingHistoryFilterBookingType,
  BookingStatusKeyStringArray,
  AllBookingStatusStrings,
  DispatcherBookingType,
  DispatcherBookingTypeTime,
  AllBookingStatus,
  bookingDriverAssignEnum,
  maxScheduleBookingDaysFromToday,
  DispatcherBookingStatusEnum,
  bookingFareType,
  BookingSetting,
  BusinessType,
  TitleStatus,
  TitleStatusString,
  BusinessTypeArray,
  BusinessTypeString
} from "../constants/bookingConstant";
import { HttpClient } from "@angular/common/http";
import * as moment from "moment-timezone";
import { DateTime, DateTimeUnit } from "luxon";
import { DOCUMENT } from "@angular/common";
import { BankTransactionStatusTypeString } from "../constants/walletConstant";
import { ToasterService } from "src/app/shared/services/toaster.service";

export interface Column {
  key: string;
  label: string;
  isDecimal?: boolean;
  isHidden?: boolean;
  isExtra?: boolean;
  isSort?: boolean;
  isDate?: boolean;
  isCurrencySign?: boolean;
  isWrap?: boolean;
  isMeterDistance?: boolean;
  isSecondTime?: boolean;
  isRate?: boolean;
}

export interface UpdatedColumnDetails {
  columns: Array<any>;
  isAdd: boolean;
}
@Injectable({
  providedIn: "root"
})
export class Helper {
  public APP_NAME = "";
  public IMAGE_URL = `${environment.IMAGE_URL}/`;
  public isDarkModeOn = false;
  cuurentLang = localStorage.getItem("theme_lang") ?? environment.defaultLang;
  public defaultLang = environment.defaultLang;
  public tooltipPlacementLeft = "left";
  public tooltipPlacementRight = "right";

  public maxPriceLength: number = 10;
  public maxTextLength: number = 50;
  public minPhoneNumberLength: number = 6;
  public secOtpResendInterval: number = 30;
  public maxPhoneNumberLength: number = 12;
  public adminSettings: any;
  public PdfSize = PdfSize;
  public NameMaxLength = NameMaxLength;
  public PerPageList = PerPageList;
  public DATE_FORMAT = DATE_FORMAT;
  public emailRegex = emailRegex;
  public UserType = UserType;
  public DriverStatus = DriverStatus;
  public DriverType = DriverType;
  public Permissions = Permissions;
  public LoginBy = LoginBy;
  public DistanceUnit = DistanceUnit;
  public PriceSign = PriceSign;
  public VehicleTypeTypes = VehicleTypeTypes;
  public DeviceTypeEnum = DeviceTypeEnum;
  public DeviceType = DeviceType;
  public BookingType = BookingType;
  public PriceMode = PriceMode;
  public BookingStatus = BookingStatus;
  public PaymentGateway = PaymentGateway;
  public PaymentGatewayType = PaymentGatewayType;
  public PaymentGatewayEnum = PaymentGatewayEnum;
  public PaymentGatewayEnumArray = PaymentGatewayEnumArray;
  public PaymentGatewayCardEnumArray = PaymentGatewayCardEnumArray;
  public PaymentGatewayHandleUrlEnumArray = PaymentGatewayHandleUrlEnumArray;
  public PaymentGatewayHandleHtmlEnumArray = PaymentGatewayHandleHtmlEnumArray;
  public PaymentPurposeType = PaymentPurposeType;
  public PaymentTransactionStatus = PaymentTransactionStatus;
  public PriceModeString = PriceModeString;
  public MapType = MapType;
  public VehicleType = VehicleType;
  public PaymentGatewayString = PaymentGatewayString;
  public DefaultImages = DefaultImages;
  public SocketEvents = SocketEvents;
  public MapBoxAccessToken = "";
  public BookingHistoryMainType = BookingHistoryMainType;
  public SetCurrencySignUnit = SetCurrencySignUnit;
  public BookingHistoryPageType = BookingHistoryPageType;
  public VariantType = VariantType;
  public BookingStatusStrings = BookingStatusStrings;
  public PaymentModeStrings = PaymentModeStrings;
  public PaymentMode = PaymentMode;
  public PaymentModeListStrings = PaymentModeListStrings;
  public BookingTypeString = BookingTypeString;
  public BookingHistoryBookingTypeArray = BookingHistoryBookingTypeArray;
  public BookingHistoryFilterBookingType = BookingHistoryFilterBookingType;
  public ExportHistoryStatusEnum = ExportHistoryStatusEnum;
  public BookingStatusKeyStringArray = BookingStatusKeyStringArray;
  public ExportType = ExportType;
  public FilterFields = FilterFields;
  public DriverTypeArray = DriverTypeArray;
  public MapPinImages = MapPinImages;
  public ChatType = ChatType;
  public MassNotificationEntities = MassNotificationEntities;
  public AllBookingStatus = AllBookingStatus;
  public AllBookingStatusStrings = AllBookingStatusStrings;
  public DispatcherBookingType = DispatcherBookingType;
  public DispatcherBookingTypeTime = DispatcherBookingTypeTime;
  public FilterType = FilterType;
  public UserTypeString = UserTypeString;
  public AddressType = AddressType;
  public AddressTypeString = AddressTypeString;
  public DriverTabTypeString = DriverTabTypeString;
  public TripTabTypeString = TripTabTypeString;
  public TripTabType = TripTabType;
  public ChargeType = ChargeType;
  public PriceParamEnum = PriceParamEnum;
  public PriceParamEnumString = PriceParamEnumString;
  public viewEstimateParamEnumString = viewEstimateParamEnumString;
  public PaymentTransactionStatusString = PaymentTransactionStatusString;
  public bookingDriverAssignEnum = bookingDriverAssignEnum;
  public maxScheduleBookingDaysFromToday = maxScheduleBookingDaysFromToday;
  public DispatcherBookingStatusEnum = DispatcherBookingStatusEnum;
  public backendMaxInt = backendMaxInt;
  public bookingFareType = bookingFareType;
  public BankTransactionStatusTypeString = BankTransactionStatusTypeString;
  public BookingSetting = BookingSetting;
  public BusinessType = BusinessType;
  public AllowBusinessType: BusinessType[] = [];
  public AllowBusinessTypeArray: { key: BusinessType; string: string }[] = [];
  public HomeScreenViewType = HomeScreenViewType;

  public imageUrl = `${environment.IMAGE_URL}/`;
  public uploadFile = ["image/jpeg", "image/jpg", "image/png"];
  public uploadDocFile = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
  public userToken: any;
  public userLoginToken: any;
  public isMainAdmin = true;
  permissions: any[] = [];
  public getLoginToken = new BehaviorSubject<any>(null);
  loginToken$ = this.getLoginToken.asObservable();
  loginToken: any;
  public resetPasswordData: any;

  public OTPSendMode = OTPSendMode;
  public userCountryPhoneCodeList: any = [];
  public panelType = UserType.DISPATCHER;
  public getCorporateDetail = new BehaviorSubject<any>(null);
  getDetails = this.getCorporateDetail.asObservable();

  public themeMode = new BehaviorSubject<any>(null);
  public themeModeChange$ = this.themeMode.asObservable();

  currencySign: string = "";
  dispatcherDetails: any;
  settingsDetails: any;
  isStripeKeyLoaded: boolean = false;
  public messageListenerAdded: boolean = false;

  public moment = moment;
  public fixedNumber = fixedNumber;
  // Same behavior as the admin panel: fall back to the viewer's own timezone instead of a
  // hardcoded one, so ride/chat/driver timestamps match what admins see for the same events.
  public displayTimezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
  public ViewType = ViewType;
  public minStripeAmount = 50;
  public showBtnLoader: boolean[] = [];
  public fromBooking: boolean = false;
  public isOtpLoginEnabledForEmail: boolean = false;
  public isOtpLoginEnabledForPhone: boolean = false;
  public isPasswordLoginEnabledForPhone: boolean = false;
  public fromCity: boolean = false;
  public businessTypeLength: number = Object.keys(BusinessType).filter((key) => isNaN(Number(key))).length;

  public mapKey: string = "";
  public mapDistanceMatrixUrl: string = `${environment.API_URL}/api/gmaps/routes/distanceMatrix/v2:computeRouteMatrix`;
  public UnitType = UnitType;
  public UnitTypeString = UnitTypeString;

  // below styles are for sdk payment modal
  width = 600;
  height = 700;
  left = window.screen.width / 2 - this.width / 2;
  top = window.screen.height / 2 - this.height / 2;

  public TitleStatus = TitleStatus;
  public TitleStatusString = TitleStatusString;
  public TimeFormatEnum = TimeFormatEnum;

  constructor(
    public route: Router,
    public translateService: TranslateService,
    public http: HttpClient,
    @Inject(DOCUMENT) private _documentRef: any,
    public toasterService: ToasterService
  ) {
    if (localStorage.getItem("userToken")) {
      this.userToken = localStorage.getItem("userToken");
    }

    this.loginToken$.subscribe((token) => {
      if (token) {
        this.loginToken = token;
      }
    });

    this.getDetails.subscribe((res) => {
      this.dispatcherDetails = res;
      if (Array.isArray(res?.entity?.businessTypes) && res?.entity?.businessTypes?.length > 0) {
        this.AllowBusinessType = res.entity.businessTypes as BusinessType[];
        this.AllowBusinessTypeArray = BusinessTypeArray.filter((bt) => this.AllowBusinessType.includes(bt.key));
      } else {
        this.AllowBusinessType = [BusinessType.TAXI];
        this.AllowBusinessTypeArray = [{ key: BusinessType.TAXI, string: BusinessTypeString[BusinessType.TAXI] }];
      }
    });
  }

  /**
   * Determines if the map type is Google.
   * @returns {boolean} True if the map type is Google, false otherwise.
   */
  mapTypeGoogle(): boolean {
    return this.adminSettings.mapType === this.MapType.GOOGLE;
  }

  /**
   * Determines if the map type is MapBox.
   * @returns {boolean} True if the map type is MapBox, false otherwise.
   */
  mapTypeMapBox(): boolean {
    return this.adminSettings?.mapType === this.MapType.MAP_BOX;
  }

    generateRandomString(length: number): string {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  copyTextToClipboard(text: string): void {
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard api method'
      navigator.clipboard
        .writeText(text)
    } else {
      // text area method
      let textArea = document.createElement("textarea");
      textArea.value = text;
      // make the textarea out of viewport
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.body.removeChild(textArea);
    }
    this.toasterService.showNotification("success", this.translateService.instant("label-title.copied-to-clipboard"));
  }

  /**
   * Updates the local storage with user data.
   */
  isUpadtedlocalStorage(): void {
    this.userToken = localStorage.getItem("userToken");
  }

  /**
   * Checks if the user has the specified permission.
   * @param type The type of permission to check.
   * @param staticName Optional static name for the permission.
   * @returns {boolean} True if the user has the permission, false otherwise.
   */
  hasPermission(type: any, staticName: any = null): boolean {
    if (!this.isMainAdmin) {
      let name = this.route.url.split("/").pop();
      if (staticName) {
        name = staticName;
      }
      const index = this.permissions.findIndex((x) => x.name === name);
      if (index !== -1) {
        const permission = this.permissions[index].permission.split("");
        if (permission[Number(type)] === "1") {
          return true;
        }
        return permission[Number(type)] === "1";
      }
      return false;
    }
    return true;
  }

  /**
   * Validator function for percentage range.
   * @param control The form control to validate.
   * @returns {ValidationErrors | null} Validation errors if invalid, null otherwise.
   */
  percentageRangeValidator(control: FormControl): { [key: string]: boolean } | null {
    const value = control.value;
    if (value !== null && (isNaN(value) || value <= 0 || value > 100)) {
      return { invalidPercentage: true };
    }
    return null;
  }

  /**
   * Handles messages from events.
   *
   * @param event The event object containing the message.
   */
  getMessage = (event: any): void => {
    if (event.data.success) {
      this.toasterService.showNotification("success", event.data.message);
      this.removeMessageListener(); // Call the method to remove the listener
    } else if (event.data.message) {
      this.toasterService.showNotification("error", event.data.message);
      this.removeMessageListener(); // Call the method to remove the listener
    }
  };

  /**
   * Removes the message listener.
   */
  removeMessageListener(): void {
    window.removeEventListener("message", this.getMessage);
    this.messageListenerAdded = false; // Reset the flag
  }

  /**
   * Validator function for arrays containing only positive numbers.
   * @returns {ValidatorFn} The validator function.
   */
  onlyNumbersValidatorForArray(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const invalidValues: Array<any> = [];
      control.value.forEach((value: any) => {
        const isValid = /^(\d+(\.\d+)?)$/.test(value.toString()) && parseFloat(value) > 0;
        if (!isValid) {
          invalidValues.push(value);
        }
      });
      return invalidValues.length === 0 ? null : { onlyPositiveNumbers: true };
    };
  }

  /**
   * Validator function for numbers without decimal points.
   * @returns {ValidatorFn} The validator function.
   */
  numbersWithOutPointValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isValid = /^\d+$/.test(control.value); // Check if the value consists only of digits 0 to 9
      return isValid ? null : { numbersWithOutPoint: true };
    };
  }

  /**
   * Validator function for positive numbers.
   * @returns {ValidatorFn} The validator function.
   */
  onlyNumbersValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const isValid = /^\d+$/.test(control.value) && parseInt(control.value, 10) > 0; // Check if the value consists only of digits and is greater than 0
      return isValid ? null : { onlyPositiveNumbers: true };
    };
  }

  /**
   * Validator function for numbers greater than zero.
   * @returns {ValidatorFn} The validator function.
   */
  numbersGreaterThanZeroValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const isValid = /^\d*\.?\d+$/.test(control.value) && parseFloat(control.value) > 0; // Check if the value consists only of digits with an optional decimal point and is greater than 0
      return isValid ? null : { numbersGreaterThanZero: true };
    };
  }

  /**
   * Generates a UUID.
   * @returns {string} The generated UUID.
   */
  get uuid(): string {
    return "xxxxxxxx-xxxx-xxx-xxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  /**
   * Gets the translated name based on the current language.
   * @param nameObject The object containing names in different languages.
   * @returns {string} The translated name.
   */
  getTranslatedName(nameObject: any): string {
    return nameObject[this.cuurentLang];
  }

  /**
   * Validates if the space key is pressed at the beginning of the input.
   * @param evt The keyboard event.
   * @returns {boolean} True if the space key is not pressed at the beginning, false otherwise.
   */
  spaceValidation(evt: any): boolean {
    return !(evt.code === "Space" && evt.target.value.length < 1);
  }

  /**
   * Validates if the input contains only numbers and a decimal point.
   * @param evt The keyboard event.
   * @returns {boolean} True if the input is valid, false otherwise.
   */
  numberValidation(evt: any): boolean {
    if ((<HTMLInputElement>evt.target).value.length >= this.maxPriceLength) {
      evt.preventDefault();
    }

    // Get the character code using the newer and more reliable key property
    const charCode = evt.key.charCodeAt(0);

    // Allow numbers (0-9), decimal point (.), and backspace (8)
    return !!((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 8);
  }

  /**
   * Prevents the input of a decimal point.
   * @param evt The keyboard event.
   * @returns {boolean} True if the input is valid, false otherwise.
   */
  pointNotAllow(evt: any): boolean {
    return evt.key !== ".";
  }

  /**
   * Validator function for password validation based on rules.
   * @param passwordRule The password rules.
   * @returns {ValidatorFn} The validator function.
   */
  passwordValidator(passwordRule: any) {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: string = control.value || "";
      const errorMessages: string[] = [];

      // Check minimum length
      if (passwordRule.minLength && value.length < passwordRule.minLength) {
        errorMessages.push(`${this.translateService.instant("label-title.be-at-least")} ${passwordRule.minLength} ${this.translateService.instant("label-title.characters-long")}`);
      }

      // Check for numbers
      if (passwordRule.requireNumbers && !/\d/.test(value)) {
        errorMessages.push(this.translateService.instant("label-title.contain-at-least-one-number"));
      }

      // Check for special characters
      if (passwordRule.requireSpecial && !/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(value)) {
        errorMessages.push(this.translateService.instant("label-title.contain-at-least-one-special-character"));
      }

      // Check for uppercase letters
      if (passwordRule.requireUppercase && !/[A-Z]/.test(value)) {
        errorMessages.push(this.translateService.instant("label-title.contain-at-least-one-uppercase-letter"));
      }

      // Check for lowercase letters
      if (passwordRule.requireLowercase && !/[a-z]/.test(value)) {
        errorMessages.push(this.translateService.instant("label-title.contain-at-least-one-lowercase-letter"));
      }

      if (errorMessages.length === 0) {
        return null; // All requirements are met
      }

      const errorMessage = `${this.translateService.instant("label-title.password-must")} ${errorMessages.join(", ")}`;
      return { invalidPassword: errorMessage };
    };
  }

  /**
   * Validates the maximum character length of a value.
   * @param value The value to validate.
   * @param maxCharacterLimit The maximum character limit.
   * @returns {boolean | null} True if the value exceeds the limit, null otherwise.
   */
  maxCharacterValidation(value: any, maxCharacterLimit: any): boolean | null {
    if (!value || value === null || value === "") {
      return null;
    }
    if (value?.toString()?.length > maxCharacterLimit) {
      return true;
    }
    return null;
  }

  /**
   * Validates and updates the error for maximum character length.
   * @param value The value to validate.
   * @param maxCharacterLimit The maximum character limit.
   * @returns {boolean | null} True if the value exceeds the limit, null otherwise.
   */
  validateAndUpdateError(value: string, maxCharacterLimit: any): boolean | null {
    return this.maxCharacterValidation(value, maxCharacterLimit);
  }

  /**
   * Validates if the input contains only alphabetic characters.
   * @param evt The keyboard event.
   * @returns {boolean} True if the input is valid, false otherwise.
   */
  alphabeticValidation(evt: KeyboardEvent): boolean {
    // Get the character code using the newer and more reliable key property
    const charCode = evt.key.charCodeAt(0);

    // Allow alphabetic characters (a-z, A-Z), space (32), backspace (8), tab (9), and arrow keys (37, 38, 39, 40)
    const isAllowed =
      (charCode >= 65 && charCode <= 90) || // A-Z
      (charCode >= 97 && charCode <= 122) || // a-z
      charCode === 32 || // Space
      charCode === 8 || // Backspace
      charCode === 9 || // Tab
      charCode === 37 || // Left arrow
      charCode === 38 || // Up arrow
      charCode === 39 || // Right arrow
      charCode === 40; // Down arrow

    if (!isAllowed) {
      evt.preventDefault();
    }
    return isAllowed;
  }

  /**
   * Validator function for validating years.
   * @param control The form control to validate.
   * @returns {ValidationErrors | null} Validation errors if invalid, null otherwise.
   */
  yearsValidation(control: AbstractControl): any {
    const date = new Date();
    if (control.value > date.getFullYear()) {
      return { yearInvalid: true };
    }
    return null;
  }

  /**
   * Validator function for phone code and number validation.
   * @param control The form control to validate.
   * @returns {ValidationErrors | null} Validation errors if invalid, null otherwise.
   */
  phoneCodeAndNumberValidator(control: AbstractControl): ValidationErrors | null {
    const countryPhoneCode = control.get("countryPhoneCode")?.value;
    const phone = control.get("phone")?.value;

    if (!countryPhoneCode && !phone) {
      return { phoneCodeAndNumberRequired: true };
    }

    return null;
  }

  /**
   * Custom validator function for confirming password match and checking if new password is the same as the current password.
   * @param control The form control to validate.
   * @returns {ValidationErrors | null} Validation errors if invalid, null otherwise.
   */
  passwordMatchValidator(control: AbstractControl): ValidationErrors | null {
    const currentPassword = control.get("password")?.value;
    const newPasswordControl = control.get("newPassword");
    const confirmPasswordControl = control.get("confirmPassword");

    if (!currentPassword || !newPasswordControl?.value || !confirmPasswordControl?.value) {
      return null;
    }

    const errors = {
      newPasswordErrors: { ...newPasswordControl.errors },
      confirmPasswordErrors: { ...confirmPasswordControl.errors }
    };

    // Check if new password is the same as the current password
    if (currentPassword === newPasswordControl.value) {
      errors.newPasswordErrors["sameAsCurrentPassword"] = true;
    } else {
      delete errors.newPasswordErrors["sameAsCurrentPassword"];
    }

    // Check if confirm password matches the new password
    if (newPasswordControl.value !== confirmPasswordControl.value) {
      errors.confirmPasswordErrors["mismatch"] = true;
    } else {
      delete errors.confirmPasswordErrors["mismatch"];
    }

    // Update control errors
    newPasswordControl.setErrors(Object.keys(errors.newPasswordErrors).length ? errors.newPasswordErrors : null);
    confirmPasswordControl.setErrors(Object.keys(errors.confirmPasswordErrors).length ? errors.confirmPasswordErrors : null);

    // Return validation result
    return newPasswordControl.errors || confirmPasswordControl.errors ? { passwordMismatch: true } : null;
  }

  /**
   * Validates the input to allow only numbers and a single decimal point.
   * @param event The input event.
   */
  validateNumberInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9.]/g, "").replace(/(\..*?)\..*/g, "$1");
  }

  /**
   * Determines the entity tag and name based on the entity type and data.
   * @param entity The entity object containing details like firstName, lastName, and name.
   * @param entityType The type of the entity: ADMIN, CUSTOMER, DRIVER, PARTNER, DISPATCHER, or CORPORATE.
   * @returns {{ entityTag: string; entityName: string }} An object containing the entity tag and name.
   */
  checkEntityTag(entity: any, entityType: number): { entityTag: string; entityName: string } {
    let entityTag;
    let entityName = "";

    switch (entityType) {
      case this.UserType.ADMIN:
        entityTag = this.translateService.instant("menu.admin").toLowerCase();
        break;
      case this.UserType.CUSTOMER:
        entityTag = this.translateService.instant("menu.user").toLowerCase();
        break;
      case this.UserType.DRIVER:
        entityTag = this.translateService.instant("menu.driver").toLowerCase();
        break;
      case this.UserType.PARTNER:
        entityTag = this.translateService.instant("menu.partner").toLowerCase();
        break;
      case this.UserType.DISPATCHER:
        entityTag = this.translateService.instant("menu.dispatcher").toLowerCase();
        break;
      case this.UserType.CORPORATE:
        entityTag = this.translateService.instant("menu.corporate").toLowerCase();
        break;
      default:
        entityTag = "";
        break;
    }

    if (entity.firstName && entity.lastName) {
      entityName = `${entity.firstName} ${entity.lastName}`;
    } else {
      entityName = entity.name || "";
    }

    return { entityTag, entityName };
  }

  /**
   * Sorts data based on the specified key and order.
   * @param key The key to sort by.
   * @param order The order of sorting (1 for ascending, -1 for descending).
   * @returns {Function} The sorting function.
   */
  sortData(key: string, order: number) {
    return (a: any, b: any): number => {
      const aValue = this.resolveKey(a, key);
      const bValue = this.resolveKey(b, key);

      if (aValue < bValue) {
        return -1 * order;
      } else if (aValue > bValue) {
        return 1 * order;
      }
      return 0;
    };
  }

  /**
   * Resolves the value of a nested key in an object.
   * @param object The object to resolve the key from.
   * @param key The nested key to resolve.
   * @returns {number} The resolved value.
   */
  resolveKey(object: any, key: string): number {
    return key.split(".").reduce((o, k) => (o && o[k] !== "undefined" ? o[k] : null), object);
  }

  /**
   * Downloads a file from the specified URL.
   * @param res The response containing the file URL.
   */
  downloadFile(res: any): void {
    const exportUrl = this.imageUrl + res;
    this.http.get(exportUrl, { responseType: "blob" as const }).subscribe((fileData) => {
      const blob: any = new Blob([fileData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const filename = res.split("xlsheet/");
      const link = document.createElement("a");

      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename[1]);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  }

  /**
   * Loads the Stripe script with the specified key.
   * @param stripeKey The Stripe key.
   * @returns {Promise<boolean>} A promise that resolves to true when the script is loaded.
   */
  loadStripe(stripeKey: string): Promise<boolean> {
    return new Promise((resolve) => {
      const start = (): void => {
        const StripeFn = (window as any).Stripe;
        if (typeof StripeFn === "function" && stripeKey) {
          const stripe = StripeFn(stripeKey);
          (window as any).stripe = stripe;
          (window as any).elements = stripe.elements();
        }
        resolve(true);
      };
      if ((window as any).Stripe) {
        start();
        return;
      }
      const script = document.createElement("script");
      script.src = "https://js.stripe.com/v3/";
      script.async = true;
      script.onload = (): void => start();
      script.onerror = (): void => resolve(false);
      document.head.appendChild(script);
    });
  }

  /**
   * Masks the phone number by replacing digits with asterisks except for the last four digits.
   * @param phoneNumber The phone number to mask.
   * @returns {string} The masked phone number.
   */
  maskPhoneNumber(phoneNumber: string): string {
    if (phoneNumber.length < 4) return phoneNumber;
    const lastFourDigits = phoneNumber.slice(-4);
    const maskedSection = phoneNumber.slice(0, -4).replace(/\d/g, "*");
    return maskedSection + lastFourDigits;
  }

  /**
   * Masks the email address by replacing characters with asterisks except for the first and last characters.
   * @param email The email address to mask.
   * @returns {string} The masked email address.
   */
  maskEmail(email: string): string {
    const [name, domain] = email.split("@");
    if (name.length < 3) return email;
    const maskedName = name[0] + name.slice(1, -2).replace(/./g, "*") + name.slice(-1);
    return `${maskedName}@${domain}`;
  }

  /**
   * Calculates the scrollable height for the table based on various element heights.
   */
  calculateScorallableHeight(): void {
    const headerHeight = document.getElementById("page-topbar")?.clientHeight ?? 0;
    const breadcrumbHeight = document.getElementById("breadcrumb-component")?.clientHeight ?? 0;
    const filterHeight = document.getElementById("filter-height")?.clientHeight ?? 0;
    const navTabsHeight = document.getElementById("nav-tab-height")?.clientHeight ?? 0;
    const paginationHeight = document.getElementById("pagination-height")?.clientHeight ?? 0;
    const appliedFiltersHeight = document.getElementById("applied-filters-height")?.clientHeight ?? 0;
    const bookingTab = document.getElementById("booking-tab")?.clientHeight ?? 0;
    const windowHeight = window.innerHeight; // Get the viewport height

    const maxHeight = windowHeight - headerHeight - breadcrumbHeight - filterHeight - navTabsHeight - paginationHeight - appliedFiltersHeight - 82; // Adjust according to
    const maxHeight2 = windowHeight - headerHeight - breadcrumbHeight - filterHeight - navTabsHeight - paginationHeight - appliedFiltersHeight - bookingTab - 114; // Adjust according to

    const tableCustomScroll = document.querySelector(".custom-scroll-height") as HTMLElement;
    const tableCustomScroll2 = document.querySelector(".custom-scroll-height-2") as HTMLElement;
    if (tableCustomScroll) {
      tableCustomScroll.style.height = `${maxHeight}px`;
      tableCustomScroll.style.overflow = "auto";
    }

    if (tableCustomScroll2) {
      tableCustomScroll2.style.height = `${maxHeight2}px`;
      tableCustomScroll2.style.overflowY = "auto";
    }
  }

  /**
   * Creates a debounced function that delays the invocation of the callback
   * until after a specified delay has passed since the last time the debounced
   * function was invoked.
   *
   * @param {Function} callback - The function to debounce.
   * @param {number} delay - The number of milliseconds to delay.
   * @return {Function} A new debounced function.
   */
  debounce<T extends (...args: any[]) => any>(callback: T, delay: number): (...args: Parameters<T>) => void {
    let timeoutId: ReturnType<typeof setTimeout>;

    return (...args: Parameters<T>): void => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        callback(...args);
      }, delay);
    };
  }

  /**
   * Gets the start and end date for a specified duration and timezone.
   * @param duration The duration unit (e.g., "week", "month").
   * @param timezone The timezone to use.
   * @param timestamp Optional timestamp to use as the reference point.
   * @returns {{ startDate: any; endDate: any }} An object containing the start and end dates.
   */
  getStartEndDate = (duration: DateTimeUnit, timezone: string, timestamp?: number): { startDate: any; endDate: any } => {
    if (!timestamp) timestamp = Date.now();
    const dt = DateTime.fromMillis(timestamp).setZone(timezone);

    // Find the start and end of the week (Sunday to Saturday)
    const startOfWeek = dt.startOf(duration);
    const endOfWeek = dt.endOf(duration);

    return {
      startDate: startOfWeek.toJSDate(),
      endDate: endOfWeek.toJSDate()
    };
  };

  /**
   * Loads the Google script with the specified URL.
   * @param url The URL of the Google script.
   * @returns {Promise<boolean>} A promise that resolves to true when the script is loaded.
   */
  loadGoogleScript(url: any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (!document.querySelector(`script[src="${url}"]`)) {
        const script = this._documentRef.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.text = ``;
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      } else {
        resolve(true);
      }
    });
  }

  /**
   * Parses address components from a place object.
   * @param place The place object containing address components.
   * @returns An object containing parsed address components.
   */
  parseAddressComponents(place: any): any {
    const lat = this.mapTypeGoogle() ? place.geometry.location.lat() : place.geometry.location.lat;

    const lng = this.mapTypeGoogle() ? place.geometry.location.lng() : place.geometry.location.lng;

    const address: any = {
      address: place.formattedAddress || place.formatted_address || place.place_name || "",
      latitude: lat,
      longitude: lng,
      country: "",
      countryCode: "",
      city: "",
      postalCode: "",
      placeId: place.placeId || place.place_id || place.id
    };

    (place.address_components || []).forEach((component: any) => {
      const types = component.types || [];

      types.forEach((type: string) => {
        const longText = component.longText || component.long_name;
        const shortText = component.shortText || component.short_name;

        if (type === "postal_code") {
          address.postalCode = longText;
        }

        if (type === "country") {
          address.country = longText;
          address.countryCode = shortText;
        }

        if (type === "locality") {
          address.city = longText;
        }

        if (type === "administrative_area_level_1" && !address.city) {
          address.city = longText;
        }

        if (type === "administrative_area_level_3" && !address.city) {
          address.city = longText;
        }

        if ((type === "place" || type === "district") && !address.city) {
          address.city = longText;
        }
      });
    });
    return address;
  }

  /**
   * Validator function for minimum value validation.
   * @param minValue The minimum value.
   * @returns {ValidatorFn} The validator function.
   */
  minValueValidator(minValue: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (value === null || value === undefined || isNaN(value) || value < minValue) {
        return { minValue: { value: value, minValue: minValue } };
      }
      return null;
    };
  }

  // map dark mode styles
  public darkModeStyles = [
    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
    {
      featureType: "administrative.locality",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }]
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }]
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#263c3f" }]
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#6b9a76" }]
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#38414e" }]
    },
    {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: [{ color: "#212a37" }]
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9ca5b3" }]
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#746855" }]
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#1f2835" }]
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#f3d19c" }]
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{ color: "#2f3948" }]
    },
    {
      featureType: "transit.station",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }]
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#17263c" }]
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#515c6d" }]
    },
    {
      featureType: "water",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#17263c" }]
    }
  ];

  /**
   * Gets the booking tag color based on the status.
   * @param status The booking status.
   * @returns {string} The booking tag color.
   */
  getBookingTagColor(status: string): string {
    let layout: any = {};
    try {
      layout = JSON.parse(localStorage.getItem("themeLayoutData") || "{}");
    } catch {
      layout = {};
    }

    if (layout.LAYOUT_MODE === "dark") {
      return this.adminSettings?.tagColor?.darkMode[status] ?? "";
    }

    return this.adminSettings?.tagColor?.lightMode[status] ?? "";
  }

  /**
   * Gets the start and end date for a specified number of days and timezone.
   * @param type The type of days ("next" or "previous").
   * @param days The number of days.
   * @param timezone The timezone to use.
   * @returns {{ startDate: any; endDate: any }} An object containing the start and end dates.
   */
  getDaysStartEndDate = (type: "next" | "previous", days: number, timezone: string): { startDate: any; endDate: any } => {
    const timestamp = Date.now();
    const dt = DateTime.fromMillis(timestamp).setZone(timezone);

    if (type === "next") {
      const startOfWeek = dt.startOf("day");
      const endOfWeek = dt.endOf("day").plus({ days: days });
      return {
        startDate: startOfWeek.toJSDate(),
        endDate: endOfWeek.toJSDate()
      };
    }
    const startOfWeek = dt.startOf("day").minus({ days: days });
    const endOfWeek = dt.endOf("day");
    return {
      startDate: startOfWeek.toJSDate(),
      endDate: endOfWeek.toJSDate()
    };
  };

  /**
   * Sets the default date filter label in the applied filters.
   * @param appliedFiltersLabels The applied filters labels.
   * @param filterData The filter data containing start and end dates.
   */
  setDefaultDateFilterLabel = (appliedFiltersLabels: any, filterData: any): void => {
    const dateFilterLabel = appliedFiltersLabels.find((item: any) => item.key === "startDate");
    if (dateFilterLabel) {
      dateFilterLabel.value = { from: filterData.startDate, to: filterData.endDate };
    } else {
      appliedFiltersLabels.push({
        key: "startDate",
        label: "label-title.date",
        value: { from: filterData.startDate, to: filterData.endDate },
        valueCount: 1,
        translate: true,
        translateToCurrentLang: false,
        isDate: true
      });
    }
  };

  /**
   * Formats the time in seconds to a human-readable string.
   * @param seconds The time in seconds.
   * @returns {string} The formatted time string.
   */
  formatTime(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    const paddedHours = String(hours).padStart(2, "0");
    const paddedMinutes = String(Math.abs(minutes)).padStart(2, "0");
    const paddedSeconds = String(Math.abs(secs)).padStart(2, "0");

    if (Number(paddedHours) > 0) {
      return `${paddedHours}:${paddedMinutes}:${paddedSeconds} ${this.translateService.instant("label-title.hour")}`;
    }
    return `${paddedMinutes}:${paddedSeconds} ${this.translateService.instant("label-title.min")}`;
  }

  /**
   * Updates all columns from local storage.
   * @param allColumns The array of all columns.
   */
  updateAllColumnsFromLocalStorage(allColumns: Array<any>): void {
    const data: any = this.route.url.split("/").pop();
    const defaultColumns: Array<any> = JSON.parse(JSON.stringify(allColumns)).filter((column: any) => !column.isExtra);

    if (this.getAddedColumns()[data]) {
      this.getAddedColumns()[data].forEach((element: any, index: number) => {
        const idx = allColumns.findIndex((item) => item.key === element.key);
        if (index !== -1 && allColumns[idx]) {
          allColumns[idx].isHidden = false;

          // Remove the item from the array
          const [item] = allColumns.splice(idx, 1);

          // Insert the item back at the desired position
          allColumns.splice(defaultColumns.length + index + 1, 0, item);
        }
      });
    }
  }

  /**
   * Gets the added columns from local storage.
   * @returns {any[]} The array of added columns.
   */
  getAddedColumns(): any[] {
    return JSON.parse(localStorage.getItem("addedColumns") ?? "{}");
  }

  /**
   * Validator function for name validation.
   * @returns {ValidatorFn} The validator function.
   */
  nameValidator(): ValidatorFn {
    const pattern: RegExp = /^[a-zA-Z-' ]*$/;
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value ? control.value.trim() : "";
      if (!pattern.test(value)) {
        return { invalidCharacters: true };
      }
      return null;
    };
  }

  dateDiffInMinutes(date1: Date, date2: Date): number {
    const diffInMs: number = date1.getTime() - date2.getTime();
    return Math.round(diffInMs / 60000);
  }

  getTimeFormat(timeFormat: any): string {
    return timeFormat || this.adminSettings?.timeFormat || this.TimeFormatEnum.TwentyFourHour;
  }

  getLocalizedTitle(title: any): string {
    return title[this.cuurentLang] ? title[this.cuurentLang] : title[this.defaultLang];
  }

  /**
   * Validates if the input value consists only of numbers without a decimal point (for phone numbers).
   * @param evt The keyboard event.
   * @returns A boolean indicating whether the input is valid.
   */
  noDecimalNumberValidationPhone(evt: any): boolean {
    const charCode = evt.key.charCodeAt(0);

    // Allow numbers (0-9) and backspace (8)
    if ((charCode >= 48 && charCode <= 57) || charCode === 8) {
      return true;
    }

    // Prevent other characters, including decimal point (.)
    evt.preventDefault();
    return false;
  }

  isSameDay(date1: Date, date2: Date): boolean {
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
  }

  roundUpValue(value: number): number {
    return Math.ceil(value);
  }

  /**
   * Combines a date and time string in the format "HH:MM [AM|PM]" into a single Date object.
   * @param date The date to combine with the time string.
   * @param timeString The time string to combine with the date, e.g. "10:15 AM".
   * @returns The combined Date object.
   */
  combineDateAndTime(date: Date, timeString: string): Date {
    const [time, modifier] = timeString.split(" "); // e.g., "10:15", "AM"
    // eslint-disable-next-line prefer-const
    let [hours, minutes] = time.split(":").map(Number);

    if (modifier === "PM" && hours < 12) {
      hours += 12;
    } else if (modifier === "AM" && hours === 12) {
      hours = 0;
    }

    const combined = new Date(date);
    combined.setHours(hours, minutes, 0, 0);
    return combined;
  }
}
